// extracted by mini-css-extract-plugin
module.exports = {"rate":"rate_plan_rate__2vTsy","flexibleContainer":"rate_plan_flexibleContainer__1qbOt"};